import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import "./styles.css";

if (import.meta.env.DEV) {
  void import("./pwa/serviceWorker").then(({ unregisterVesselServiceWorker }) =>
    unregisterVesselServiceWorker(),
  ).catch(() => undefined);
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
